import React from 'react';
import {
    VStack,
    FormControl,
    FormLabel,
    Input,
    Button,
    Text,
    Box,
    Divider,
    HStack,
    IconButton,
    Tag,
    Switch,
    Select as ChakraSelect,
    Collapse
} from '@chakra-ui/react';
import { LuTrash2, LuClock } from 'react-icons/lu';

export default function ButtonClickedProperties({
    nodeConfig,
    setNodeConfig,
    updateNodeData,
    setSelectedNode
}) {
    const buttons = nodeConfig.buttons || [
        { name: '', id: 'button_1', conditionEnabled: false, conditionTime: 60, conditionUnit: 'minutes', conditionReference: 'message_sent' },
        { name: '', id: 'button_2', conditionEnabled: false, conditionTime: 60, conditionUnit: 'minutes', conditionReference: 'message_sent' },
        { name: '', id: 'button_3', conditionEnabled: false, conditionTime: 60, conditionUnit: 'minutes', conditionReference: 'message_sent' }
    ];

    const handleButtonChange = (index, field, value) => {
        const newButtons = [...buttons];
        newButtons[index] = {
            ...newButtons[index],
            [field]: value,
        };
        setNodeConfig({ ...nodeConfig, buttons: newButtons });
    };

    const handleRemoveButton = (index) => {
        const newButtons = [...buttons];
        newButtons[index] = {
            name: '',
            id: `button_${index + 1}`,
            conditionEnabled: false,
            conditionTime: 60,
            conditionUnit: 'minutes',
            conditionReference: 'message_sent'
        };
        setNodeConfig({ ...nodeConfig, buttons: newButtons });
    };

    const getActiveButtons = () => {
        return buttons.filter(btn => btn.name && btn.name.trim() !== '');
    };

    const getButtonColor = (index) => {
        const colors = [
            { bg: 'var(--brand-primary)', text: 'blue.500' },
            { bg: '#9333ea', text: 'purple.500' },
            { bg: '#22c55e', text: 'green.500' }
        ];
        return colors[index] || colors[0];
    };

    return (
        <VStack spacing={4} align="stretch">
            <FormControl>
                <FormLabel fontSize="sm">Step Name</FormLabel>
                <Input
                    size="sm"
                    value={nodeConfig.label || ''}
                    onChange={(e) => setNodeConfig({ ...nodeConfig, label: e.target.value })}
                    placeholder="e.g., Product Selection"
                />
            </FormControl>

            <Divider />

            <Box>
                <HStack justify="space-between" mb={3}>
                    <FormLabel fontSize="sm" mb={0}>Configure Buttons</FormLabel>
                    <Tag variant="outline" fontSize="xs" size="sm">
                        Max 3 buttons
                    </Tag>
                </HStack>

                <VStack spacing={3} align="stretch">
                    {[0, 1, 2].map((index) => {
                        const button = buttons[index];
                        const isActive = button.name && button.name.trim() !== '';
                        const color = getButtonColor(index);

                        return (
                            <Box
                                key={index}
                                p={3}
                                border="1px"
                                borderRadius="md"
                                bg={isActive ? `var(--brand-50)` : 'gray.50'}
                                borderColor={isActive ? `#a3b3ff` : 'gray.200'}
                            >
                                <HStack justify="space-between" mb={2}>
                                    <HStack>
                                        <Text fontSize="xs" fontWeight="semibold">
                                            Button {index + 1}
                                        </Text>
                                        {isActive && (
                                            <Tag
                                                variant="outline"
                                                fontSize="10px"
                                                size="sm"
                                                bg="green.50"
                                                color="green.700"
                                                borderColor="green.200"
                                            >
                                                Active
                                            </Tag>
                                        )}
                                    </HStack>
                                    {isActive && (
                                        <IconButton
                                            size="xs"
                                            variant="ghost"
                                            colorScheme="red"
                                            icon={<LuTrash2 size={14} />}
                                            onClick={() => handleRemoveButton(index)}
                                        />
                                    )}
                                </HStack>

                                <FormControl mb={3}>
                                    <FormLabel fontSize="xs">
                                        Button Name (from webhook payload)
                                    </FormLabel>
                                    <Input

                                        size="sm"
                                        value={button.name || ''}
                                        onChange={(e) => handleButtonChange(index, 'name', e.target.value)}
                                        placeholder={
                                            index === 0 ? 'e.g., Confirm Order' :
                                                index === 1 ? 'e.g., Cancel' :
                                                    'e.g., Reschedule'
                                        }
                                        fontFamily="mono"
                                        fontSize="xs"
                                    />
                                    <Text fontSize="xs" color="gray.600" mt={1}>
                                        Enter the exact button name as received in webhook
                                    </Text>
                                </FormControl>

                                {/* Per-Button Condition */}
                                {/* {isActive && (
                                    <Box mt={3} pt={3} borderTop="1px" borderColor="gray.200" >
                                        <HStack justify="space-between" mb={2}>
                                            <Box>
                                                <Text fontSize="xs" fontWeight="medium">
                                                    Time-based Condition
                                                </Text>
                                                <Text fontSize="xs" color="gray.600">
                                                    Route based on when button is clicked
                                                </Text>
                                            </Box>
                                            <Switch
                                                size="sm"
                                                isChecked={button.conditionEnabled || false}
                                                onChange={(e) => handleButtonChange(index, 'conditionEnabled', e.target.checked)}
                                            />
                                        </HStack>

                                        <Collapse in={button.conditionEnabled} animateOpacity>
                                            <VStack spacing={2} align="stretch" p={2} bg={"#fffbeb"} border="1px" borderColor="#fee685" borderRadius="md" mt={2}>
                                                <HStack>
                                                    <Box flex={1}>
                                                        <FormLabel fontSize="xs" mb={1}>Time Limit</FormLabel>
                                                        <Input
                                                            bg={"white"}
                                                            size="xs"
                                                            type="number"
                                                            // min={0}
                                                            value={button.conditionTime }
                                                            onChange={(e) => handleButtonChange(index, 'conditionTime', parseInt(e.target.value) )}
                                                        />
                                                    </Box>
                                                    <Box flex={1}>
                                                        <FormLabel fontSize="xs" mb={1}>Unit</FormLabel>
                                                        <ChakraSelect
                                                            size="xs"
                                                            value={button.conditionUnit || 'minutes'}
                                                            onChange={(e) => handleButtonChange(index, 'conditionUnit', e.target.value)}
                                                            bg={"white"}
                                                        >
                                                            <option value="minutes">Minutes</option>
                                                            <option value="hours">Hours</option>
                                                            <option value="days">Days</option>
                                                        </ChakraSelect>
                                                    </Box>
                                                </HStack>

                                                <Box>
                                                    <FormLabel fontSize="xs" mb={1}>Calculated From</FormLabel>
                                                    <ChakraSelect
                                                        size="xs"
                                                        value={button.conditionReference || 'message_sent'}
                                                        onChange={(e) => handleButtonChange(index, 'conditionReference', e.target.value)}
                                                        bg={"white"}
                                                    >
                                                        <option value="flow_trigger">Flow Trigger</option>
                                                        <option value="message_sent">Message Sent</option>
                                                        <option value="message_delivered">Message Delivered</option>
                                                        <option value="message_read">Message Read</option>
                                                    </ChakraSelect>
                                                </Box>

                                                <Box fontSize="10px" color="amber.700" bg="amber.100" px={2} py={1.5} borderRadius="md">
                                                    <HStack spacing={1} mb={1}>
                                                        <LuCheckCircle size={10} color="#15803d" />
                                                        <Text fontWeight="semibold">True Path:</Text>
                                                    </HStack>
                                                    <Text mb={2}>Clicked within {button.conditionTime} {button.conditionUnit}</Text>

                                                    <HStack spacing={1} mb={1}>
                                                        <LuXCircle size={10} color="#dc2626" />
                                                        <Text fontWeight="semibold">False Path:</Text>
                                                    </HStack>
                                                    <Text>Not clicked within {button.conditionTime} {button.conditionUnit}</Text>
                                                </Box>
                                            </VStack>
                                        </Collapse>
                                    </Box>
                                )} */}
                            </Box>
                        );
                    })}
                </VStack>
            </Box>

            <Divider />

            {/* No Click Fallback Configuration */}
            <Box>
                <HStack justify="space-between" mb={3}>
                    <Box>
                        <FormLabel fontSize="sm" mb={0}>No Click Fallback</FormLabel>
                        <Text fontSize="xs" color="gray.600" mt={0.5}>
                            Route when NO button is clicked at all
                        </Text>
                    </Box>
                    <Switch
                        isChecked={nodeConfig.noClickWaitEnabled || false}
                        onChange={(e) => setNodeConfig({
                            ...nodeConfig,
                            noClickWaitEnabled: e.target.checked
                        })}
                    />
                </HStack>

                <Collapse in={nodeConfig.noClickWaitEnabled} animateOpacity>
                    <VStack spacing={3} align="stretch" p={3} bg="gray.50" border="1px" borderColor="gray.300" borderRadius="md">
                        <HStack spacing={2} fontSize="xs" color="gray.700">
                            <LuClock size={14} />
                            <Text fontWeight="medium">Wait time before routing to no-click path</Text>
                        </HStack>

                        <HStack>
                            <Box flex={1}>
                                <FormLabel fontSize="xs">Wait Time</FormLabel>
                                <Input
                                    size="sm"
                                    type="number"
                                    min={1}
                                    value={nodeConfig.noClickWaitTime || 60}
                                    onChange={(e) => setNodeConfig({
                                        ...nodeConfig,
                                        noClickWaitTime: parseInt(e.target.value) || 1
                                    })}
                                />
                            </Box>
                            <Box flex={1}>
                                <FormLabel fontSize="xs">Unit</FormLabel>
                                <ChakraSelect
                                    size="sm"
                                    value={nodeConfig.noClickWaitUnit || 'minutes'}
                                    onChange={(e) => setNodeConfig({
                                        ...nodeConfig,
                                        noClickWaitUnit: e.target.value
                                    })}
                                >
                                    <option value="minutes">Minutes</option>
                                    <option value="hours">Hours</option>
                                    <option value="days">Days</option>
                                </ChakraSelect>
                            </Box>
                        </HStack>

                        <Box>
                            <FormLabel fontSize="xs">Calculated From</FormLabel>
                            <ChakraSelect
                                size="sm"
                                value={nodeConfig.noClickWaitReference || 'message_sent'}
                                onChange={(e) => setNodeConfig({
                                    ...nodeConfig,
                                    noClickWaitReference: e.target.value
                                })}
                            >
                                <option value="flow_trigger">Flow Trigger</option>
                                <option value="message_sent">Message Sent</option>
                                <option value="message_delivered">Message Delivered</option>
                                <option value="message_read">Message Read</option>
                            </ChakraSelect>
                        </Box>

                        <Box fontSize="xs" color="gray.700" bg="gray.100" px={2} py={1.5} borderRadius="md">
                            <Text fontWeight="medium" mb={1}>Note:</Text>
                            <Text>
                                If no button is clicked within {nodeConfig.noClickWaitTime || 60} {nodeConfig.noClickWaitUnit || 'minutes'} from{' '}
                                {nodeConfig.noClickWaitReference === 'flow_trigger' && 'flow trigger'}
                                {nodeConfig.noClickWaitReference === 'message_sent' && 'message sent'}
                                {nodeConfig.noClickWaitReference === 'message_delivered' && 'message delivered'}
                                {nodeConfig.noClickWaitReference === 'message_read' && 'message read'},
                                route through the "No Click" path.
                            </Text>
                        </Box>
                    </VStack>
                </Collapse>
            </Box>

            <Divider />

            {/* Connection Routes Preview */}
            {/* <Box>
                <FormLabel fontSize="sm" mb={3}>Connection Routes</FormLabel>

                <VStack spacing={2} align="stretch">
                    {getActiveButtons().map((button, index) => {
                        const color = getButtonColor(index);
                        const hasCondition = button.conditionEnabled;

                        return (
                            <Box key={button.id}>
                                {hasCondition ? (
                                    <VStack spacing={2} align="stretch">

                                        <Box
                                            p={2}
                                            bg="green.50"
                                            border="1px"
                                            borderColor="green.200"
                                            borderRadius="md"
                                        >
                                            <HStack spacing={2} mb={1}>
                                                <LuCheckCircle size={14} color="#22c55e" />
                                                <Text fontSize="xs" fontWeight="semibold" color="green.700">
                                                    {button.name} - Clicked In Time
                                                </Text>
                                            </HStack>
                                            <Text fontSize="10px" color="gray.600">
                                                Within {button.conditionTime} {button.conditionUnit} from {button.conditionReference?.replace('_', ' ')}
                                            </Text>
                                        </Box>

                                        <Box
                                            p={2}
                                            bg="red.50"
                                            border="1px"
                                            borderColor="red.200"
                                            borderRadius="md"
                                        >
                                            <HStack spacing={2} mb={1}>
                                                <LuXCircle size={14} color="#ef4444" />
                                                <Text fontSize="xs" fontWeight="semibold" color="red.700">
                                                    {button.name} - Not In Time
                                                </Text>
                                            </HStack>
                                            <Text fontSize="10px" color="gray.600">
                                                After {button.conditionTime} {button.conditionUnit} from {button.conditionReference?.replace('_', ' ')}
                                            </Text>
                                        </Box>
                                    </VStack>
                                ) : (
                                    <Box
                                        p={2}
                                        bg={`${color.text}.50`}
                                        border="1px"
                                        borderColor={`${color.text}.200`}
                                        borderRadius="md"
                                    >
                                        <HStack spacing={2}>
                                            <LuMousePointerClick size={14} style={{ color: color.bg }} />
                                            <Text fontSize="xs" fontWeight="semibold" color={color.text}>
                                                {button.name}
                                            </Text>
                                        </HStack>
                                    </Box>
                                )}
                            </Box>
                        );
                    })}

                   
                    {nodeConfig.noClickWaitEnabled && (
                        <Box
                            p={2}
                            bg="gray.50"
                            border="1px"
                            borderColor="gray.300"
                            borderRadius="md"
                        >
                            <HStack spacing={2} mb={1}>
                                <LuClock size={14} color="#9ca3af" />
                                <Text fontSize="xs" fontWeight="semibold" color="gray.700">
                                    No Click
                                </Text>
                            </HStack>
                            <Text fontSize="10px" color="gray.600">
                                After {nodeConfig.noClickWaitTime} {nodeConfig.noClickWaitUnit} with no button clicked
                            </Text>
                        </Box>
                    )}

                    {getActiveButtons().length === 0 && !nodeConfig.noClickWaitEnabled && (
                        <Box
                            p={4}
                            bg="gray.50"
                            border="1px"
                            borderColor="gray.200"
                            borderRadius="md"
                            borderStyle="dashed"
                            textAlign="center"
                        >
                            <Text fontSize="xs" color="gray.600">
                                No active routes configured yet
                            </Text>
                        </Box>
                    )}
                </VStack>

                <Alert status="info" borderRadius="md" mt={4} size="sm">
                    <AlertIcon as={LuAlertCircle} />
                    <Box fontSize="xs">
                        <Text fontWeight="medium" mb={1}>How This Works</Text>
                        <AlertDescription>
                            Each button can have time-based conditions creating True/False paths.
                            The "No Click" fallback triggers when NO button is clicked at all within the specified time.
                        </AlertDescription>
                    </Box>
                </Alert>
            </Box>

            <Divider /> */}

            <HStack>
                <Button
                    size="sm"
                    variant="outline"
                    onClick={() => setSelectedNode && setSelectedNode(null)}
                >
                    Cancel
                </Button>
                <Button
                    size="sm"
                    colorScheme="purple"
                    onClick={updateNodeData}
                    flex={1}
                >
                    Update Node
                </Button>
            </HStack>
        </VStack>
    );
}